import { Icon, IconProps } from "@chakra-ui/react";

interface NumericCheckboxIconProps extends IconProps {
  isChecked?: boolean;
  isIndeterminate?: boolean;
  index: number;
}
export function NumericCheckboxIcon({
  isChecked = false,
  isIndeterminate = false,
  index = 0,
  ...rest
}: NumericCheckboxIconProps) {
  if (!isChecked || isIndeterminate) return null;
  return (
    <Icon viewBox="0 0 30 30" {...rest}>
      <text fill="currentColor" fontSize="28" textAnchor="middle" x="14" y="27">
        {index}
      </text>
    </Icon>
  );
}